const BACKEND = 'https://cinedar.com:8444'
const CURRENCY = 'PEN'
const CURRENCY_LANG = 'en-EN'

export { BACKEND, CURRENCY, CURRENCY_LANG };
